let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7FkEF"), load("6dn79")]).then(() => parcelRequire('j5yhG'));